import { graphql } from 'gatsby';
import * as React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Layout } from '../components/layout';
import PrivacyPolicy from '../components/PrivacyPolicy/privacyPolicy';
import Seo from '../components/seo';

const isSandbox = process.env.GATSBY_ENV !== 'production';

const PrivacyPolicyPage = ({ pageContext }) => {
  const { t } = useTranslation();

  if (isSandbox) {
    if (typeof window !== 'undefined') {
      window.location.replace('/');
    }
    return null;
  }

  return (
    <Layout>
      <Seo title={t('trans.privacyPolicyPage')} lang={pageContext.language} />
      <PrivacyPolicy />
    </Layout>
  );
};
export default PrivacyPolicyPage;

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
